var exports = {
  "kL": "xaf9ae18d--61572c--container",
  "hm": "xaf9ae18d--61572c--middle-indent",
  "Tv": "xaf9ae18d--61572c--large-indent",
  "W6": "xaf9ae18d--61572c--large-indent--redesign",
};

module.exports = exports;
